import { render } from "./Payouts.vue?vue&type=template&id=f5b7c34e&ts=true"
import script from "./Payouts.vue?vue&type=script&lang=ts"
export * from "./Payouts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__